export const SAVE_UTKAST_DEBOUNCE_DELAY = 1200;
export const TEXT_FIELD_MAX_LENGTH = 2000;

export const TIMEZONE_FOR_DISPLAY = "Europe/Oslo";
export const LOCALE = "nb-NO";
export const DATE_HIDE_YEAR_IF_THIS_YEAR = true;

export const DEMO_SIMULATED_BACKEND_DELAY_MS = 300;
